import React from 'react';
import { getEstadoBadge } from '../../features/turnos/utils/turnoUtils';

const StatusBadge = ({ status, estado, variant, procesador, subEstado }) => {
  const estadoFinal = status || estado;
  const variantFinal = variant || getEstadoBadge(estadoFinal);
  const textoEstado = subEstado ? `${estadoFinal} - ${subEstado}` : estadoFinal;
  
  return (
    <span className={`status-badge status-${variantFinal}`}>
      <div>{textoEstado || 'Sin estado'}</div>
      {procesador && (
        <div style={{ fontSize: '0.85em', marginTop: '2px', opacity: 0.9 }}>
          {procesador}
        </div>
      )}
    </span>
  );
};

export default StatusBadge;
